import React from 'react';
import { Link } from 'react-router-dom';
import image from '../assets/images/icon.png'
import MainLayout from '../components/layouts/MainLayout';
import { useAuth } from '../utils/AuthHooks';

function NotFoundPage() {
  let auth = useAuth();

  if (auth.isAuthenticated) {
    return(
      <MainLayout>
        <div className="container-fluid">
          <div className="text-center">
            <div className="error mx-auto" data-text="404">404</div>
            <p className="lead text-gray-800 mb-5">Page Not Found</p>
            <Link to="/" className="btn btn-primary">
              Kembali ke Dashboard
            </Link>
          </div>
        </div>
      </MainLayout>
    )
  }

  return (
    <div className="login-page-wrapper bg-gradient-primary" style={{minHeight: "100vh", padding: "100px 0"}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card o-hidden border-0 shadow-lg">
              <div className="card-body p-5">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center mb-5">
                      <img src={image} alt="Blue Viberlink Logo" className="mb-5" style={{maxWidth: "200px"}}/>
                      <h1 className="h1 text-gray-900 mb-2">404</h1>
                      <h3 className="h5 text-gray-900 mb-4">Not Found</h3>
                      <Link to="/" className="btn btn-primary">
                        Kembali ke Dashboard
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
